import type { ReactNode } from "react";

import { createContext, useContext } from "react";

import type { PerformanceReportAnalytics } from "../types";

const PerformanceReportAnalyticsContext = createContext<
  PerformanceReportAnalytics | undefined
>(undefined);

export const PerformanceReportAnalyticsProvider = ({
  analytics,
  children,
}: {
  analytics?: PerformanceReportAnalytics;
  children: ReactNode;
}) => (
  <PerformanceReportAnalyticsContext.Provider value={analytics}>
    {children}
  </PerformanceReportAnalyticsContext.Provider>
);

export const usePerformanceReportAnalyticsContext = () =>
  useContext(PerformanceReportAnalyticsContext);
